import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import ChannelFactory from './ChannelFactory.vue';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import ChannelDirectory from './ChannelDirectory.vue';
import ChannelTypePage from './ChannelTypePage.vue';
import Settings from './Settings.vue';
import InboxChannel from './InboxChannels.vue';
import AddAgents from './AddAgents.vue';
import FinishSetup from './FinishSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_inbox_list', params: to.params };
          },
        },
        // Phase 9.6: the single inbox list became "All channels" and one page per type; old links land on the former.
        {
          path: 'list',
          name: 'settings_inbox_list',
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator'],
          },
          redirect: to => ({ name: 'settings_channels', params: to.params }),
        },
        // Phase 9.7: the inbox page has its own header (name + tabs), so it lives in the plain frame.
        {
          path: ':inboxId/:tab?',
          name: 'settings_inbox_show',
          component: Settings,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator'],
            // Topbar trail (R2-9-10): the channel list is the link back, the inbox name is the page.
            trailParent: 'settings_channels',
            trailDetail: (route, store) =>
              store.getters['inboxes/getInbox'](route.params.inboxId)?.name,
            // one inbox's page: not kept alive by SettingsWrapper (it re-rendered for the next route)
            keepAlive: false,
          },
        },
      ],
    },
    // D-S3 / R2-9-3 = A (phase 9.6): "All channels" (also step 1 of a new inbox) and one page per channel type.
    {
      path: frontendURL('accounts/:accountId/settings/channels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_channels',
          component: ChannelDirectory,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator'],
          },
        },
        {
          path: ':channelType',
          name: 'settings_channel_type',
          component: ChannelTypePage,
          meta: {
            featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/inboxes'),
      component: SettingsContent,
      props: {
        headerTitle: 'INBOX_MGMT.HEADER',
      },
      children: [
        {
          path: 'new',
          component: InboxChannel,
          children: [
            {
              path: '',
              name: 'settings_inbox_new',
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator'],
              },
              redirect: to => ({
                name: 'settings_channels',
                params: to.params,
              }),
            },
            {
              path: ':inbox_id/finish',
              name: 'settings_inbox_finish',
              component: FinishSetup,
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator'],
              },
            },
            {
              path: ':sub_page',
              name: 'settings_inboxes_page_channel',
              component: ChannelFactory,
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator'],
              },
              props: route => {
                return { channelName: route.params.sub_page };
              },
            },
            {
              path: ':inbox_id/agents',
              name: 'settings_inboxes_add_agents',
              meta: {
                featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
                permissions: ['administrator'],
              },
              component: AddAgents,
            },
          ],
        },
      ],
    },
  ],
};
